import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IPushServiceState {
    connectionId?: string | null;
}

const initialState: IPushServiceState = {
    connectionId: null,
}

export const pushServiceSlice = createSlice({
    name: 'pushService',
    initialState,
    reducers: {
        pushServiceConnected: (state, action: PayloadAction<string | null | undefined>) => {
            state.connectionId = action.payload;
        },
        pushServiceReconnected: (state, action: PayloadAction<string | null | undefined>) => {
            state.connectionId = action.payload;
        },
        clearPushServiceConnectionId: (state) => {
            state.connectionId = null;
        }
    }
});

export const {
    pushServiceReconnected,
    pushServiceConnected,
    clearPushServiceConnectionId,
} = pushServiceSlice.actions;

export default pushServiceSlice.reducer;